// import SmartphoneMiniStyle from './Smartphone-mini.style'
// import styleSheet from './AllWebChatStyle.style'
// import withStyles from 'material-ui/styles/withStyles'
// export default withStyles(styleSheet)(WebChatNewConsultation)
// const classes = this.props.classes;

const CLINTAL_BLUE = '#5A8DDA'
const CLINTAL_CHAT_GRAY = 'rgb(211, 211, 211)'
const CLINTAL_BLACK = '#858484'

const webChatStyle = (theme) => ({
  //--- WebChatSearchForm.jsx --

  searchForm: {
    padding: '20px 20px',
  },
  searchForm_firstDiv: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'spaceBetween',
    verticalAlign: 'bottom',
    marginBottom: '15px',
  },
  searchForm_title: {
    fontSize: '18px',
    margin: 0,
    fontWeight: 'bold',
    color: CLINTAL_BLUE,
  },
  searchForm_submit: {
    border: '1px solid #b0b0b0',
  },
  searchForm_icon: {
    width: '5%',
    paddingLeft: '5px',
  },
  searchForm_input: {
    padding: '6px 0 6px 10px',
    width: '95%',
    border: 'none',
  },

  //--- WebChatNewConsultation.jsx ---

  consult: {
    padding: '20px 20px 10px',
  },
  consult_firstDiv: {
    paddingBottom: '10px',
  },
  consult_secondDiv: {
    borderTop: '2px solid rgb(245, 245, 245)',
    paddingBottom: '10px',
  },
  consult_title: {
    fontSize: '18px',
    margin: '0',
    fontWeight: 'bold',
    color: CLINTAL_BLUE,
  },
  consult_consultationContent: {
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '12px',
  },
  consult_Q: {
    fontSize: '27px',
    paddingRight: '12px',
    color: CLINTAL_BLUE,
  },
  consult_user: {
    fontSize: '12px',
    textAlign: 'right',
  },
  consult_img: {
    marginRight: '5px',
  },
  consult_answerDate: {
    marginLeft: '20px',
  },
  chat_flex02: {
    flex: 0.2,
  },
  chat_flex8: {
    flex: 1,
    flexDirection: 'column',
    marginLeft: 10,
    color: '#2C3B4E',
  },
  chat_hospitalBorder: {
    border: '1px #ddd solid',
    margin: 10,
  },

  chat_chatPadding: {
    padding: 10,
  },
  chat_hospitalBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    color: '#2C3B4E',
  },
  chat_hospitalDoctor: {
    display: 'flex',
    flexDirection: 'row',
  },
  chat_hospitalAddress: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 5,
  },
  //--- WebChatUserPlan.jsx ---

  userPlan: {
    position: 'relative',
    overflow: 'hidden',
    padding: '35px 20px 20px',
  },
  userPlan_ribbon: {
    backgroundColor: CLINTAL_BLUE,
    height: '20px',
    width: '90px',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '10px',
    textAlign: 'center',
    position: 'absolute',
    top: '12px',
    left: '-26px',
    transform: 'rotate(-45deg)',
  },
  userPlan_firstDiv: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    verticalAlign: 'bottom',
    borderBottom: '2px solid #f5f5f5',
    marginBottom: '15px',
    paddingBottom: '10px',
  },
  userPlan_secondDiv: {},
  userPlan_name: {
    fontSize: '18px',
    margin: '0',
    fontWeight: 'bold',
    color: CLINTAL_BLUE,
  },
  userPlan_price: {
    fontSize: '13px',
    color: '#d3d3d3',
  },
  userPlan_content: {
    marginTop: '15px',
  },
  userPlan_date: {
    fontSize: '14px',
    color: '#565656',
  },
  userPlan_chatCount: {
    fontSize: '14px',
    color: CLINTAL_BLUE,
  },

  //--- WebChatSend.jsx ---

  chatSend_container: {
    padding: '5px 5px 5px',
  },
  chatSend_textArea: {
    borderRadius: 3,
    border: '1px solid #ccc',
    width: '100%',
  },
  chatSend_submit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  chatSend_button: {
    display: 'flex',
    flex: 1,
    borderRadius: 5,
    backgroundColor: CLINTAL_BLUE,
    height: '95%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  chatSend_fileAttachButton: {
    backgroundColor: CLINTAL_CHAT_GRAY,
    border: '1px solid #999',
  },

  //--- WebChatChat.jsx ---

  chat_nurseImg: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    position: 'relative',
    zIndex: 10,
  },

  chat_nurseContent: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },

  chat_nurseChatTail: {
    position: 'absolute',
    zIndex: 2,
    top: 5,
    left: 3,
    height: 15,
    width: 15,
    backgroundColor: 'white',
    borderRadius: 100 / 2,
  },

  chat_nurseChatTailSub: {
    position: 'absolute',
    zIndex: 3,
    top: 5,
    left: '-7px',
    height: 20,
    width: 20,
    backgroundColor: '#F6F5F5',
    borderRadius: 100 / 2,
  },

  chat_nurseChat: {
    fontSize: 'small',
    maxWidth: 380,
    marginLeft: 12,
    backgroundColor: 'white',
    wordBreak: 'break-all',
    borderRadius: 12,
    padding: 10,
    position: 'relative',
    zIndex: 5,
  },
  chat_nurseChatContent: {
    color: '#2C3B4E',
  },
  chat_createdAt: {
    color: CLINTAL_CHAT_GRAY,
    fontSize: 11,
    paddingLeft: 5,
  },

  chat_hospitalContent: {
    overflow: 'auto',
    whiteSpace: 'nowrap',
    '-webkit-scrollbar': 'none',
    margin: '0',
    maxWidth: 800,
  },
  chat_hospitalIntro: {
    fontSize: 'small',
    backgroundColor: 'white',
    borderRadius: 5,
    padding: '20px 30px',
    margin: 10,
    display: 'inline-block',
  },
  chat_hospitalInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  chat_userContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  chat_userChat: {
    fontSize: 'small',
    maxWidth: 380,
    wordBreak: 'break-all',
    backgroundColor: CLINTAL_BLUE,
    borderRadius: 12,
    padding: 10,
    position: 'relative',
    zIndex: 5,
  },
  chat_flag: {
    color: CLINTAL_CHAT_GRAY,
    fontSize: 11,
    paddingRight: 5,
  },

  chat_submitDate: {
    margin: '10px 0',
    color: CLINTAL_CHAT_GRAY,
  },
  chat_chatBox: {
    position: 'relative',
  },

  chat_userChatTail: {
    position: 'absolute',
    zIndex: 2,
    top: 5,
    right: '-9px',
    height: 15,
    width: 15,
    backgroundColor: CLINTAL_BLUE,
    borderRadius: 100 / 2,
  },

  chat_userChatTailSub: {
    position: 'absolute',
    zIndex: 3,
    top: 6,
    right: '-19px',
    height: 20,
    width: 20,
    backgroundColor: '#F6F5F5',
    borderRadius: 100 / 2,
  },

  chat_reviewSend: {
    borderRadius: 5,
    backgroundColor: CLINTAL_BLUE,
    height: '95%',
    width: '25%',
    position: 'relative',
    left: '70%',
  },

  like_btn_circle: {
    position: 'absolute',
    border: '1px solid #F6F5F5',
    backgroundColor: 'white',
    height: 18,
    width: 18,
    borderRadius: '50%',
    right: '-4px',
    bottom: '-8px',
    zIndex: 10,
  },

  like_btn_heart: {
    height: '100%',
    width: '100%',
    color: '#a9a9a9',
    display: 'flex',
    position: 'absolute',
    top: 0,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 2,
  },

  chat_cannotSendReview: {
    borderRadius: 5,
    backgroundColor: CLINTAL_CHAT_GRAY,
    height: '95%',
    width: '25%',
    position: 'relative',
    left: '70%',
  },

  chat_starIcon: {
    color: CLINTAL_BLUE,
    height: 40,
    width: 40,
    margin: '5px 0',
  },

  chat_reviewMessageArea: {
    borderRadius: 3,
    borderColor: CLINTAL_CHAT_GRAY,
    padding: 5,
    height: 150,
    width: '100%',
  },

  chat_reviewScore: {
    display: 'flex',
    justifyContent: 'center',
  },

  //--- WebChatIndex.jsx ---

  index_sideBar: {
    height: '100%',
  },
  index_chatTitle: {
    textAlign: 'center',
    paddingTop: 10,
    paddingBottom: 10,
  },
  index_chatIndex: {},
  webChatIndex: {
    padding: '15px 200px',
    backgroundColor: '#F6F5F5',
  },
  index_paper: {
    padding: '8px 20px 0',
  },
  index_chatLogs: {
    background: '#F6F5F5',
    height: '45vh',
  },
  index_chatScroll: {
    overflow: 'auto',
    height: '44vh',
  },
  index_chatReset: {
    display: 'flex',
    border: '1px solid #ccc',
    borderRadius: 12,
    borderColor: CLINTAL_BLUE,
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px 5px 20px 5px',
    padding: '5px',
    width: '50%',
  },
  index_chatPrevious: {
    display: 'flex',
    border: '1px solid #ccc',
    borderRadius: 12,
    borderColor: CLINTAL_BLUE,
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px 5px 20px 5px',
    padding: '5px',
    width: '50%',
  },
  index_block_previous: {
    display: 'flex',
    border: '1px solid #ccc',
    borderRadius: 12,
    borderColor: CLINTAL_CHAT_GRAY,
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px 5px 20px 5px',
    padding: '5px',
    width: '50%',
  },
  index_chat_control_btns: {
    display: 'flex',
    width: '100%',
  },
  index_clintalApp: {
    objectFit: 'cover',
    width: '100%',
  },

  index_appImgBox: {
    margin: 10,
  },
  index_appIos: {
    width: '45%',
    float: 'left',
  },

  index_appAndroid: {
    width: '45%',
    float: 'right',
    marginBottom: 5,
  },
  index_dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  index_dialogButton: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'space-around',
  },

  // WebChatIndex.jsx nonModal={true} 差分

  webView_webChatIndex: {
    padding: '10px 10px', // サイド余白削減
    height: '90vh', // 縦幅が大きい機種でフッターがせり出すのを防ぐ
    backgroundColor: '#F6F5F5',
  },
  webView_index_paper: {
    padding: '8px 10px 0px', // サイド余白削減
  },
  webView_chatOpen: {
    display: 'none', // モーダル切替ボタンは常に非表示
  },

  // WebChatBotChoice

  botChoice_subTitle: {
    color: '#2C3B4E',
    textAlign: 'center',
  },
  botChoice_content: {
    height: '18vh',
    overflowY: 'auto',
    marginTop: 10,
  },
  botChoice_userChoise: {
    border: '1px solid #ccc',
    borderRadius: 5,
    borderColor: CLINTAL_BLUE,
    width: '32%',
    height: '4em',
    margin: 3,
    padding: '10px 0 10px 15px',
    float: 'left',
    whiteSpace: 'normal',
  },

  botChoice_faildGetLocation: {
    border: '1px solid #ccc',
    borderRadius: 5,
    backgroundColor: '#bababa',
    width: '32%',
    height: '4em',
    margin: 3,
    padding: '10px 0 10px 15px',
    float: 'left',
    whiteSpace: 'normal',
  },

  // WebChatChangeUserPlanModal

  planModal_close: {
    position: 'absolute',
    right: 20,
    display: 'flex',
    flexDirection: 'column',
    color: CLINTAL_BLUE,
    fontSize: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  planModal_img: {
    margin: '50px auto 30px',
    display: 'block',
  },
  planModal_content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'rgb(211, 211, 211)',
  },
  planModal_title: {
    fontSize: 24,
    color: 'black',
  },

  // All webchat component style

  planModalContent: {
    padding: '40px 110px',
  },
  circle: {
    width: 30,
    height: 30,
    borderRadius: 100 / 2,
    backgroundColor: CLINTAL_CHAT_GRAY,
  },
  index_chatPaper: {
    display: 'none',
  },
  index_chatModalTitle: {
    backgroundColor: CLINTAL_BLUE,
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 18,
  },

  chatOpenbutton: {
    width: '100%',
    backgroundColor: CLINTAL_BLUE,
    borderRadius: 50,
    padding: '10px 0',
    fontSize: 16,
  },
  chatOpen: {
    display: 'none',
  },
  test1: {
    color: 'red',
  },
  modal_priBtn: {
    backgroundColor: CLINTAL_BLUE,
    color: 'white',
    borderRadius: 30,
    marginBottom: 10,
    padding: 10,
    width: 250,
    marginTop: 15,
  },
  modal_defBtn: {
    backgroundColor: 'white',
    color: CLINTAL_BLUE,
    borderRadius: 30,
    marginBottom: 10,
    padding: 10,
    width: 250,
  },
  textWhite: {
    color: 'white',
  },
  textBlack: {
    color: '#2C3B4E',
  },
  textBlue: {
    color: CLINTAL_BLUE,
  },
  textGray: {
    color: CLINTAL_CHAT_GRAY,
  },
  textRed: {
    color: 'red',
  },

  // WebChatChatModal

  chatModal_closeBtn: {
    fontSize: 20,
    display: 'inlineBlock',
    position: 'absolute',
    right: 10,
  },
  chatModal_date: {
    backgroundColor: '#405263',
    width: '100%',
    color: 'white',
    marginBottom: 10,
    letterSpacing: 0.5,
    fontSize: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 5,
  },
  chatModal_nurseImg: {
    marginRight: 7,
  },
  chatModal_dateContent: {
    color: '#68aab6',
    fontSize: 12,
  },

  paper: {
    margin: 0,
  },

  // WebChatRedisterRecommendModal

  recModal_closeBtn: {
    position: 'absolute',
    right: 20,
    display: 'flex',
    flexDirection: 'column',
    color: CLINTAL_BLUE,
    fontSize: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  recModal_img: {
    margin: '50px auto 30px',
    display: 'block',
  },
  recModal_content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  recModal_content_alert: {
    maxWidth: '330px',
  },

  // WebChatCreditCardModal

  cardModal_closeBtn: {
    position: 'absolute',
    right: 20,
    display: 'flex',
    flexDirection: 'column',
    color: CLINTAL_BLUE,
    fontSize: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardModal_title: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 18,
    color: CLINTAL_BLACK,
    marginTop: 20,
  },
  cardModal_content: {
    backgroundColor: '#f6f5f5',
    padding: '10px 30px',
    color: CLINTAL_BLUE,
    width: '100%',
  },
  cardModal_center: {
    display: 'flex',
    alignItems: 'center',
  },
  cardModal_contentItem: {
    color: CLINTAL_BLACK,
    float: 'left',
  },
  cardModal_btnForm: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  //--- smartphone, smartphone-mini ---
  '@media only screen and (min-width: 320px) and (max-width: 812px)': {
    webChatIndex: {
      padding: '10px 20px',
      backgroundColor: '#F6F5F5',
    },
    planModalContent: {
      padding: '40px 30px ',
    },
    index_paper: {
      display: 'none',
      padding: '8px 20px 0',
    },
    chatOpen: {
      display: 'flex',
      margin: '10px 0 15px',
    },
    index_chatLogs: {
      height: '40vh',
    },
    index_chatScroll: {
      height: '39vh',
    },
    botChoice_userChoise: {
      width: 'auto',
      padding: 12,
      float: 'none',
      height: 'auto',
    },
    botChoice_faildGetLocation: {
      width: 'auto',
      padding: 12,
      float: 'none',
      height: 'auto',
    },
    botChoice_content: {
      height: '19vh',
    },
  },

  //--- tablet ---

  '@media only screen and (min-width: 813px) and (max-width: 1366px)': {
    webChatIndex: {
      padding: '15px 50px',
      backgroundColor: '#F6F5F5',
    },
    planModalContent: {
      padding: '40px 110px ',
    },
  },
})

export default webChatStyle
